export default __webpack_public_path__ + "static/media/webforce_logo.393005f5.png";